module.exports = __webpack_public_path__ + "static/media/img_0.e234a451.png";